// 试卷管理
import request from '@/router/axios';

let urlPrefix = '/api/exam/etexampaper';

/**
 * 组卷
 * @param {Object} data 试卷对象
 * @param {Number} data.paperDifficulty 试题难度系数(0.0 ~ 1.0)
 * @param {String} data.paperName 试卷名称
 * @param {Number} data.paperPoint 试卷总分
 * @param {String} data.paperType 试卷类型
 * @param {Number} data.passPoint 及格分数
 * @param {Object} data.questionKnowledgePointRate 试题知识点比例
 * @param {Float}  data.questionKnowledgePointRate.{章节id} 该章节下题数量占比
 * @param {Object} data.questionTypeNum 试题类型数量
 * @param {Number} data.questionTypeNum.{试题类型id} 该类试题数量
 * @param {Object} data.questionTypePoint 试题类型分数
 * @param {Float}  data.questionTypePoint.{试题类型id} 该类试题分数
 * @param {Number} data.time 试卷持续时间
 */
export const createEtexampaper = data => {
  return request(`${urlPrefix}/create`, {
    data
  }, 'post');
};

/**
 * 保存试卷
 * @param {Number} examPaperId 试卷id
 * @param {Number} duration 时长
 * @param {Object} data 试卷分数对象
 * @param {Number} data.{试题id} 试题分数
 */
export const saveEtexampaper = (examPaperId, duration, data) => {
  return request(`${urlPrefix}/update-exampaper/${examPaperId}/${duration}`, {
    data
  }, 'put');
};

/**
 * 获取所有试卷
 */
export const getEtexampapers = () => {
  return request(`${urlPrefix}/all`);
};

/**
 * 获取试卷详情
 * @param {Number} id 试卷id
 */
export const getEtexampaperDetail = id => {
  return request(`${urlPrefix}/${id}`);
};

/**
 * 分页查询试卷列表
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {Object} params 其他参数
 */
export const getEtexampaperList = (page = 1, limit = 10, params = {}) => {
  return request(`${urlPrefix}/query`, {
    params: {
      ...params,
      page,
      limit
    }
  });
};

/**
 * 批量删除
 * @param {Array} data 
 */
export const deletePaper = data => {
    return request(`${urlPrefix}/deleteBatch`, { data }, 'delete');
};
